// extracted by mini-css-extract-plugin
module.exports = {"root":"m-singlex__3FPOij_f"};